<template>
  <div class="base-info">
    <a-form-model ref="ruleForm" :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
                  :model="ruleForm" :rules="rules">
      <a-card :bordered="false" title="基础信息" :headStyle="{paddingLeft:'0px'}">
        <a-form-model-item label="商户编号">
          {{ detailInfo.merchantCode }}
        </a-form-model-item>
        <a-form-model-item label="商户认证">
          {{ detailInfo.merchantAuthStatusText }}
        </a-form-model-item>
        <!--        <a-form-model-item label="主营类目">-->
        <!--          {{detailInfo.merchantBusiness}}-->
        <!--        </a-form-model-item>-->
        <a-form-model-item label="品牌logo" prop="merchantIcon">
          <div class="upload-box">
            <a-upload
              v-model="ruleForm.merchantIcon"
              :action="uploadFileUrl"
              :multiple="false"
              :showUploadList="false"
              listType="picture-card"
              @change="fileInfo=>handleChange(fileInfo)"
              :before-upload="handleBeforeUploadImage"
            >
              <img style="width: 80px;height: 80px" v-if="ruleForm.merchantIcon" :src="ruleForm.merchantIcon"
                   alt="avatar" class="image"/>
              <div v-else>
                <a-icon :type="uploading? 'loading' : 'plus'"/>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item label="平台名称" prop="merchantFullName">
          <a-input :maxLength="10" v-model="ruleForm.merchantFullName" placeholder="输入品牌名，不超过10个字"
                   style="width: 100%"></a-input>
        </a-form-model-item>
        <a-form-model-item label="平台推广语" prop="merchantAdvertising">
          <a-textarea
            placeholder="您的平台已开启，为了更方便客户了解您的平台，快来补充推广语吧~"
            style="max-width: 400px"
            :maxLength="80"
            :rows="6"
            v-model="ruleForm.merchantAdvertising"
          ></a-textarea>
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" title="商户类型" v-if="detailInfo&&detailInfo.firstAuth==1">
        <a-form-model-item label="商户类型" prop="merchantType">
          <a-radio-group v-model='ruleForm.merchantType'>
            <a-radio v-for='(item,index) in merchantTypeList' :key='index' :value="item.code">{{ item.name }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" title="经营品类" v-if="detailInfo&&detailInfo.firstAuth==1">
        <a-form-model-item label="经营品类" prop="saleProductList">
          <a-checkbox-group v-model='ruleForm.saleProductList'>
            <a-checkbox v-for='(item,index) in categoryList' :key='index' :value="item.code">{{
                item.name
              }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" title="联系方式">
        <a-form-model-item label="管理人邮箱" prop="merchantEmail">
          <a-input v-model="ruleForm.merchantEmail" placeholder="请输入邮箱" style="width: 100%"></a-input>
        </a-form-model-item>
        <a-form-model-item label="管理人手机号">
          <a-input :value="getShowMobile(mobileShow)" placeholder="管理人手机号" disabled style="width: 100%"></a-input>
          <a-tooltip placement="topLeft" style="margin-left: 15px">
            <template slot="title">
              <span>管理人手机号即主账号登录手机号，如有更改需求，请“设置-安全设置”中修改</span>
            </template>
            <a-icon type="info-circle"/>
          </a-tooltip>
        </a-form-model-item>
        <a-form-model-item label="紧急联系人姓名" prop="merchantContact">
          <a-input placeholder="请输入" v-model="ruleForm.merchantContact" style="width: 100%"></a-input>
        </a-form-model-item>
        <a-form-model-item label="紧急联系人号码" prop="merchantCustomerPhone">
          <a-input placeholder="请输入" v-model="ruleForm.merchantCustomerPhone" style="width: 100%"></a-input>
        </a-form-model-item>
        <a-form-model-item label="图形验证码" v-if="isShowSmcode">
          <div style="clear: both">
            <a-input
              :maxLength="4"
              style="width: 260px"
              v-model="ruleForm.verificationImg"
              placeholder="请输入">
            </a-input>
            <img style="width:130px;height:31px;margin-left:10px;" :src="imageCodeUrl" alt="验证码" class="img-code"
                 @click="restImageCodeUrl()">
          </div>
        </a-form-model-item>
        <!--        :required="true" prop="smsCode"-->
        <a-form-model-item label="安全验证码" v-if="isShowSmcode">
          <a-input
            placeholder="请输入"
            style="width: 260px"
            :maxLength="6"
            v-model="ruleForm.smsCode"
          />
          <a-button v-if="second<=0" style="margin-left:10px;width:130px;" @click="getSmsCode()">获取验证码</a-button>
          <a-button v-else style="margin-left: 10px;width:130px;">{{ second }}秒后重新发送</a-button>
        </a-form-model-item>
        <a-form-model-item label="联系地址">
          <a-cascader
            style="max-width: 400px;"
            :options="provinceList"
            @change="onCityChange"
            :value='defaultValue'
            placeholder="请选择所在省市城市"
          />
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-input v-model="ruleForm.merchantAddress" placeholder="请输入详细地址" style="width: 100%"></a-input>
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false" style="margin-bottom: 0">
          <p style="line-height: 25px">
            以上地址将作为经营者相关争议解决的唯一有效送达地址，请认真填写，如有不实，相关法律后果按《魔方云平台合作协议》处理。</p>
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false">
          <p style="line-height: 25px">
            <a-checkbox style="margin-right: 10px" @change="onChange"></a-checkbox>
            我声明，此页面内容由本公司自行填写和发布，内容真实有效，如有相关法律法规、平台协议及平台规则之规定冲突的，以法律法规、平台协议及平台规则规定为准
          </p>
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-button type="primary" @click="saveEvent" :loading="saveLoading" style="width:100px;">保存</a-button>
        </a-form-model-item>

      </a-card>
    </a-form-model>
  </div>
</template>

<script>
import formMixins from '../../../utils/mixins/formMixins'
import countDownHelper from '@/utils/helper/countDownHelper'
import { USER_INFO_KEY } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

export default {
  name: 'BasicInfoComponents',
  mixins: [formMixins],
  data() {
    return {
      businessFileList: [],
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 4 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 20 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        merchantIcon: '',// logo ,
        merchantFullName: '',// 商户全称 ,
        merchantAdvertising: '',// 宣传语 ,
        merchantEmail: '',// 管理人邮箱,
        merchantContact: '',// 业务联系人 ,
        merchantCustomerPhone: '',// 联系人电话 ,
        verificationImg: '',//图形码
        smsCode: '',// 短信验证码
        merchantAreaId: '',// 所在区域
        merchantCityId: '',// 所在城市ID ,
        merchantProvinceId: '',// 所在省份ID ,
        merchantAddress: '',// 详细地址 ,
        merchantMobile: this.$store.getters.userInfo.mobile,// 管理人电话
        //以下详情接口获取
        merchantAuthStatus: '',// 认证状态 ,
        merchantAuthStatusText: '',// 认证状态字符串展示 ,
        merchantBusiness: '',// 商户业务 ,
        merchantCode: '',// 商户编号 ,
        merchantId: '',// 商户id ,
        merchantIsAudit: '',// 审核状态 ,
        merchantType: '',//商户类型 1经销商 2分销商 3供应商
        saleProductList: []//运营品类 1门票,2酒店,3签证,8抢购,5百货,75自由行,100行程/线路
      },
      rules: {
        merchantIcon: [
          { required: true, message: '请输入品牌logo', trigger: 'blur' }
        ],
        merchantFullName: [
          { required: true, message: '请输入平台名称', trigger: 'blur' }
        ],
        merchantAdvertising: [
          { required: true, message: '请输入平台推广语', trigger: 'blur' }
        ],
        merchantEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
            message: '邮箱格式不正确'
          }
        ],
        merchantContact: [
          { required: true, message: '请输入紧急联系人姓名', trigger: 'blur' }
        ],
        merchantCustomerPhone: [
          { required: true, message: '请输入紧急联系人手机', trigger: 'blur' }
        ],
        merchantType: [
          { required: true, message: '请选择商户类型', trigger: 'blur' }
        ],
        saleProductList: [
          { required: true, message: '请选择经营品类', trigger: 'blur' }
        ]
      },
      provinceList: [],
      defaultValue: [],
      uploading: false,
      mobileShow: this.$store.getters.userInfo.mobile,
      imageCodeUrl: '',
      randomNum: '',
      second: 0,
      detailInfo: '',
      uploadFileUrl: this.getAppConfig().baseUrl + 'base/upload',
      isCheck: false,
      ruleFormInfo: '',
      isShowSmcode: false,
      merchantTypeList: [],
      categoryList: []
    }
  },
  mounted() {
    this.getProvinceList()
    this.restImageCodeUrl()
    this.getMerchantTypeList()
    this.getCategoryList()
    this.getDetail()
  },
  computed: {
    newMerchantEmail() {
      return this.ruleForm.merchantEmail
    },
    newMerchantCustomerPhone() {
      return this.ruleForm.merchantCustomerPhone
    },
    newMerchantContact() {
      return this.ruleForm.merchantContact
    },
    newMerchantAreaId() {
      return this.ruleForm.merchantAreaId
    },
    newMerchantAddress() {
      return this.ruleForm.merchantAreaId
    }
  },
  watch: {
    newMerchantEmail(val) {
      this.styele()
    },
    newMerchantCustomerPhone(val) {
      this.styele()
    },
    newMerchantContact(val) {
      this.styele()
    },
    newMerchantAreaId(val) {
      this.styele()
    },
    newMerchantAddress(val) {
      this.styele()
    }
  },
  methods: {
    getMerchantTypeList() {
      this.getHttpServices().getServerApiService().get('enum/getMerchantTypeEnum')
        .then(res => {
          if (res) {
            this.merchantTypeList = res
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCategoryList() {
      this.getHttpServices().getServerApiService().get('enum/getSaleProductEnum')
        .then(res => {
          if (res) {
            this.categoryList = res
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    styele() {
      if (this.ruleForm.merchantEmail != this.ruleFormInfo.merchantEmail || this.ruleForm.merchantCustomerPhone != this.ruleFormInfo.merchantCustomerPhone || this.ruleForm.merchantContact != this.ruleFormInfo.merchantContact || this.ruleForm.merchantAreaId != this.ruleFormInfo.merchantAreaId || this.ruleForm.merchantAddress != this.ruleFormInfo.merchantAddress) {
        this.isShowSmcode = true
      } else {
        this.isShowSmcode = false
      }
    },
    getShowMobile(mobile) { //手机号码格式化
      if (mobile && mobile.length > 3) {
        return mobile.substr(0, 3) + '****' + mobile.substr(mobile.length - 4)
      }
      return mobile
    },
    getProvinceList() { //获取地址
      this.getHttpServices().getBaseService().get('province/getProvinceCityCounty').then(res => {
        this.provinceList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCityChange(value) { //地址修改
      if (value && value.length) {
        this.ruleForm.merchantAreaId = value[2]// 所在区域
        this.ruleForm.merchantCityId = value[1]// 所在城市ID ,
        this.ruleForm.merchantProvinceId = value[0]// 所在省份ID ,
        this.defaultValue = [value[0], value[1], value[2]]
        console.log(this.defaultValue)
      }
    },
    //文件变更监听
    handleChange(fileInfo) {
      if (fileInfo.file.status === 'uploading') {
        this.uploading = true
      } else if (fileInfo.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(fileInfo.fileList)
        this.ruleForm.merchantIcon = url//上传后的图片地址
        this.uploading = false
      }
    },
    // //获取图片上传地址
    // getUploadFileUrl(){
    //   let appConfig = this.getAppConfig();
    //   return appConfig.baseUrl+ (appConfig.isDev?'/':'' )+'base/caertificateAnalysis'
    // },
    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    },
    getSmsCode() { //图片验证码
      const verificationImg = this.ruleForm.verificationImg
      if (verificationImg && (typeof verificationImg === 'string' || typeof verificationImg === 'number')) {
        const params = {
          effect: 8,
          mobile: this.mobileShow,
          randomNum: this.randomNum,
          userType: 1,
          verificationImg: verificationImg,
          isValidationImg: false
        }
        this.getHttpServices().getBaseService().post('sms/verification', params)
          .then(res => {
            this.$message.success('短信验证码已经发送')
            this.startTimer()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.success('请输入图形验证码')
      }

    },
    startTimer() { //倒计时
      if (!this.timer) {
        this.timer = new countDownHelper(60000, 1000)
        this.timer.onCountDownListener = (timeInfo) => {
          this.second = timeInfo.second
        }
        this.timer.onFinishListener = () => {
          this.second = 0
          this.timer = undefined
        }
        this.timer.start()
      }
    },
    getDetail() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getUserService().get('api/v2/merchant/detail', params)
        .then(res => {
          this.detailInfo = res
          this.ruleForm = {
            merchantIcon: res.merchantIcon,// logo ,
            merchantFullName: res.merchantFullName,// 商户全称 ,
            merchantAdvertising: res.merchantAdvertising,// 宣传语 ,
            merchantEmail: res.merchantEmail,// 管理人邮箱,
            merchantContact: res.merchantContact,// 业务联系人 ,
            merchantCustomerPhone: res.merchantCustomerPhone,// 联系人电话 ,
            merchantAreaId: res.merchantAreaId,// 所在区域
            merchantCityId: res.merchantCityId,// 所在城市ID ,
            merchantProvinceId: res.merchantProvinceId,// 所在省份ID ,
            merchantAddress: res.merchantAddress,// 详细地址 ,
            merchantType: res.merchantType,
            saleProductList: res.saleProductList
          }
          this.ruleFormInfo = {
            merchantIcon: res.merchantIcon,// logo ,
            merchantFullName: res.merchantFullName,// 商户全称 ,
            merchantAdvertising: res.merchantAdvertising,// 宣传语 ,
            merchantEmail: res.merchantEmail,// 管理人邮箱,
            merchantContact: res.merchantContact,// 业务联系人 ,
            merchantCustomerPhone: res.merchantCustomerPhone,// 联系人电话 ,
            merchantAreaId: res.merchantAreaId,// 所在区域
            merchantCityId: res.merchantCityId,// 所在城市ID ,
            merchantProvinceId: res.merchantProvinceId,// 所在省份ID ,
            merchantAddress: res.merchantAddress// 详细地址 ,
          }
          this.defaultValue = [res.merchantProvinceId, res.merchantCityId, res.merchantAreaId]
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    saveEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData() {
      if (!this.isCheck) {
        this.$message.warn('请勾选声明')
        return
      }
      if (!this.ruleForm.merchantIcon) {
        this.$message.warn('请上传品牌logo')
        return
      }
      if (this.isShowSmcode) {
        const verificationImg = this.ruleForm.verificationImg
        if (verificationImg && (typeof verificationImg === 'string' || typeof verificationImg === 'number')) {
        } else {
          this.$message.warn('请输入图形验证码')
          return
        }
        if (!this.ruleForm.smsCode) {
          this.$message.warn('请输入短信验证码')
          return
        }
      }
      const params = {
        merchantAddress: this.ruleForm.merchantAddress,
        merchantAdvertising: this.ruleForm.merchantAdvertising, //宣传语 ,
        merchantAreaId: this.ruleForm.merchantAreaId,// 所在区域 ,
        merchantAuthStatus: this.detailInfo.merchantAuthStatus,// 认证状态 ,
        merchantAuthStatusText: this.detailInfo.merchantAuthStatusText,// 认证状态字符串展示 ,
        merchantBusiness: this.detailInfo.merchantBusiness,// 商户业务 ,
        merchantCityId: this.ruleForm.merchantCityId,// 所在城市ID ,
        merchantCode: this.detailInfo.merchantCode,// 商户编号 ,
        merchantContact: this.ruleForm.merchantContact,// 业务联系人 ,
        merchantCustomerPhone: this.ruleForm.merchantCustomerPhone,// 联系人电话 ,
        merchantEmail: this.ruleForm.merchantEmail,// 管理人邮箱 ,
        merchantFullName: this.ruleForm.merchantFullName,// 商户全称 ,
        merchantIcon: this.ruleForm.merchantIcon,// logo ,
        merchantId: this.$store.getters.userInfo.merchantId,// 商户id ,
        merchantIsAudit: this.detailInfo.merchantIsAudit,// 审核状态 ,
        merchantMobile: this.$store.getters.userInfo.mobile,// 管理人电话 ,
        merchantProvinceId: this.ruleForm.merchantProvinceId,// 所在省份ID ,
        smsCode: this.ruleForm.smsCode// 短信验证码
        // merchantType:this.ruleForm.merchantType,
        // saleProductList:this.ruleForm.saleProductList,
      }
      if (this.detailInfo && this.detailInfo.firstAuth == 1) {
        params.merchantType = this.ruleForm.merchantType
        params.saleProductList = this.ruleForm.saleProductList
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('api/v2/merchant/submit', params)
        .then(res => {
          this.$message.success('保存成功')
          //setTimeout(()=>this.backEvent(),500)
          this.setMerchantInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    onChange(e) {
      this.isCheck = e.target.checked
    },
    setMerchantInfo() {
      this.getLogUtils().logWithTag('运营商登录信息1', this.$ls.get(USER_INFO_KEY))
      let merchantInfo = this.$ls.get(USER_INFO_KEY)
      merchantInfo.shopLogo = this.ruleForm.merchantIcon
      merchantInfo.merchantName = this.ruleForm.merchantFullName
      this.$store.commit('SET_AVATAR', this.ruleForm.merchantIcon)
      this.$store.commit('SET_NAME', { name: this.ruleForm.merchantFullName })
      this.$ls.set(USER_INFO_KEY, merchantInfo, 7 * 24 * 60 * 60 * 1000)
      this.getLogUtils().logWithTag('运营商登录信息2', this.$ls.get(USER_INFO_KEY))
    }
  }
}
</script>
<style lang="less" scoped>

</style>